// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3-2lu","footer":"ModalFilter_footer__3qfe4"};